import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'

export const StyledFormLink = styled(Link)(() => ({
  color: '#1C47CB',
  fontSize: '14px'
}))

export const StyledFormLinkDisabled = styled(Link)(({ theme }) => ({
  color: theme.palette.customGrey[500],
  fontSize: '14px',
  pointerEvents: 'none',
  textDecoration: 'none'
}))
